import Http from "../util/Http";

class OrderApi {
    static async getOrders(page, isTotal = false) {
        const queryString = new URLSearchParams({
            page,
            size: 30,
            isTotal
        }).toString();
        const res = await Http.get(`/order?${queryString}`);
        return res || [];
    }

}

export default OrderApi;